import {gql} from '@apollo/client';

export const GetPurchasesLimitation = gql`
    query GetPurchasesLimitation($childId: ChildId!) {
        limitationSettings {
            packageLimitationSettings {
                childProfile {
                    purchasesLimitationWithChild(childId: $childId)
                }
            }
        }
    }
`;

export const GetAutomaticPricingForPurchases = gql`
    query GetAutomaticPricingForPurchases($siteId: SiteId!, $childIds: [ChildId!]!) {
        finance {
            purchases {
                automaticPricing(siteId: $siteId, childIds: $childIds) {
                    children {
                        childId
                        ruleGroups {
                            ruleGroupId
                            pricing {
                                pricingGroupId
                                dates {
                                    from
                                    to
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
